/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25Canais.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function Renegociacao25Canais() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-canais">
        <ContainerHome24>
          <div className="canais-principal">
            <div className="canais-textos">
              <h2 className="canais-titulo">Canais oficiais</h2>
              <p className="canais-texto">
                Você consegue fazer tudo o que faria em uma agência Santander:
              </p>
            </div>
            <div className="canais-carrossel">
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                // hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <a
                        href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?redirect=https%3A%2F%2Fapi.whatsapp.com%2Fsend%3Fphone%3D551140049090%26text%3DOl%C3%A1%2C%20Santander%20Financiamentos&int_source=portalSF&int_medium=renegociacao:card-whatsapp:link&int_campaign=acessar"
                        target="_blank"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-whatsapp.svg" alt="" />
                          <p className="canais-card-titulo">Whatsapp</p>
                        </div>
                        <p className="canais-card-link">Acessar</p>
                        {typeof window === 'undefined' ? (
                          <></>
                        ) : (
                          <>
                            {width >= 992 && (
                              <img
                                src="assets/renegociacao25/canais/qrcode-whatsapp-reneg_v2.png"
                                alt="qrcode whatsapp"
                                className="qrcode-whatsapp"
                              />
                            )}
                          </>
                        )}
                      </a>
                    </div>
                    <div className={`slide ${className}`}>
                      <a
                        href="mailto:negociemais@santander.com.br"
                        target="_blank"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-email.svg" alt="" />
                          <p className="canais-card-titulo">E-mail</p>
                        </div>
                        <p className="canais-card-link link-email">negociemais@santander.com.br</p>
                      </a>
                    </div>
                    <div className={`slide ${className}`}>
                      <div
                        onClick={() => {
                          setShowMsg(!showMsg);
                        }}
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-sms.svg" alt="" />
                          <p className="canais-card-titulo">SMS interativo</p>
                        </div>
                        <p className="canais-card-link ">Negociação por SMS</p>
                      </div>
                    </div>
                    <div className={`slide ${className}`}>
                      <a
                        href="tel:40049090"
                        id="tel-4004-9090"
                        target="_blank"
                        rel="noopener"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-central.svg" alt="" />
                          <p className="canais-card-titulo">Central de relacionamento</p>
                        </div>
                        <p className="canais-card-link">4004-9090</p>
                      </a>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
          <div className={`canais-show-sms ${showMsg ? 'expanded' : ''}`}>
            <div className="canais-sms-imagem">
              <img src="assets/renegociacao25/canais/ic_mobile_message.svg" alt="" />
            </div>
            <div className="canais-sms-conteudo">
              <div className="canais-sms-textos">
                <p className="canais-sms-titulo">Regularize sua dívida por SMS</p>
                <p className="canais-sms-texto">
                  Você poderá receber uma mensagem para <b>regularizar contratos</b> em atraso por
                  meio do SMS interativo.
                  <br />
                  Atente-se para não cair em golpes:{' '}
                </p>
              </div>
              <div className="canais-sms-dicas">
                <div className="canais-sms-dica">
                  <p className="canais-sms-dica-number">1. </p>
                  <p className="canais-sms-dica-texto">
                    Nunca forneça dados sigilosos, como senhas, ID Santander e dados pessoais;
                  </p>
                </div>
                <div className="canais-sms-dica">
                  <p className="canais-sms-dica-number">2. </p>
                  <p className="canais-sms-dica-texto">
                    Desconfie de mensagens que pedem para você instalar programas ou aplicativos;
                  </p>
                </div>
                <div className="canais-sms-dica">
                  <p className="canais-sms-dica-number">3. </p>
                  <p className="canais-sms-dica-texto">
                    Desconfie de mensagens que pedem atualização de cadastro.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width <= 992 && (
              <picture className="img-separador-reneg">
                <source type="image/webp" srcSet="assets/renegociacao25/separador-reneg.webp" />
                <source type="image/png" srcSet="assets/renegociacao25/separador-reneg.png" />
                <img
                  src="assets/renegociacao25/separador-reneg.png"
                  alt="Mulher branca feliz dirigindo um carro após realizar uma renegociação fácil e segura com um parceiro da Santander Financiamentos."
                />
              </picture>
            )}
            {width > 992 && (
              <picture className="img-separador-reneg">
                <source
                  type="image/webp"
                  srcSet="assets/renegociacao25/separador-reneg-desk.webp"
                />
                <source type="image/png" srcSet="assets/renegociacao25/separador-reneg-desk.png" />
                <img
                  src="assets/renegociacao25/separador-reneg-desk.png"
                  alt="Mulher branca feliz dirigindo um carro após realizar uma renegociação fácil e segura com um parceiro da Santander Financiamentos."
                />
              </picture>
            )}
          </>
        )}
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25Canais;
